var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpleadoss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 135.794 111.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Usuario_Icon",
    "data-name": "Usuario Icon",
    transform: "translate(653.14 -596.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_71",
    "data-name": "Grupo 71",
    transform: "translate(-651.64 598.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75",
    "data-name": "Trazado 75",
    d: "M-351.129,680.314a2.151,2.151,0,0,0,.223.42A54.248,54.248,0,0,1-333.6,712.5c.146.834.6.879,1.251.879,8.76-.01,17.519.009,26.279-.016,3.089-.009,4.86-1.875,4.836-4.964a33.218,33.218,0,0,0-23.456-31.188A32.785,32.785,0,0,0-351.129,680.314Zm16.706-47.363a18.814,18.814,0,0,0-18.82,18.792,18.822,18.822,0,0,0,18.8,18.814,18.82,18.82,0,0,0,18.823-18.8A18.815,18.815,0,0,0-334.423,632.951Z",
    transform: "translate(434.032 -617.74)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76",
    "data-name": "Trazado 76",
    d: "M-644.64,828.251c.443-2.437.759-4.9,1.348-7.3a45.989,45.989,0,0,1,38.461-34.782,46.023,46.023,0,0,1,51.786,37.689,58.335,58.335,0,0,1,.731,7.548c.121,3-1.776,4.864-4.764,4.865q-41.411.011-82.822.014c-2.408,0-3.8-1.313-4.741-3.328Z",
    transform: "translate(644.64 -728.144)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77",
    "data-name": "Trazado 77",
    d: "M-543.433,578.087a14.305,14.305,0,0,1,2.924.3,41.466,41.466,0,0,1,4.088.983c11.28,3.58,18.33,14.232,17.472,26.3-.8,11.212-9.835,20.9-21.182,22.71a25.373,25.373,0,0,1-29.1-21.56,25.318,25.318,0,0,1,21.871-28.478h.008a19.653,19.653,0,0,1,2.675-.252Z",
    transform: "translate(590.315 -578.087)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpleadoss);
export default __webpack_public_path__ + "static/media/Empleadoss.d444ff1c753f666e4f1778c7e8b23027.svg";
export { ForwardRef as ReactComponent };